<template>
    <div>
        <vs-row>
            <vs-col vs-lg="6" vs-sm="12" class="p-1">
                <div class="grey_holder p-4">
                    <h6 class="mb-8">Payment Frequency</h6>
                    <div>
                        <vs-radio class="mr-6" v-model="frequency" vs-name="frequency" vs-value="daily">Daily</vs-radio>
                        <vs-radio class="mr-6" v-model="frequency" vs-name="frequency" vs-value="weekly">Weekly</vs-radio>
                        <vs-radio class="mr-6" v-model="frequency" vs-name="frequency" vs-value="monthly">Monthly</vs-radio>
                    </div>
                </div>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12" class="p-1">
                <div style="height: 96.6px; overflow-y: auto;" class="grey_holder vertical_scrollbar p-4">
                    <div class="flex flex-wrap">
                        <div class="lg:w-1/4 md:w-1/2 w-full p-1">
                            <label class="vs-input--label mb-2">Payment Method</label>
                            <v-select class="cstm_vue_select w-full" :options="paymentOptionArray" :reduce="(option)=>option.id" v-model="payout_settings.payment_option"/>
                        </div>
                        <div class="lg:w-1/4 md:w-1/2 w-full p-1">
                            <label class="vs-input--label">Account Name</label>
                            <vs-input placeholder="Enter name" class="w-full" v-model="payout_settings.account_name" />
                        </div>
                        <div class="lg:w-1/4 md:w-1/2 w-full p-1">
                            <label class="vs-input--label">Sort Code</label>
                            <vs-input placeholder="Enter sort code" class="w-full" v-model="payout_settings.sort_code"/>
                        </div>
                        <div class="lg:w-1/4 md:w-1/2 w-full p-1">
                            <label class="vs-input--label">Account No</label>
                            <vs-input placeholder="Enter A/C no." class="w-full" v-model="payout_settings.account_number"/>
                        </div>
                    </div>
                </div>
            </vs-col>
            <vs-col vs-type="flex" vs-w="12" class="p-1 my-4">
                <h5 class="pr-2">Custom Payment Settings</h5>
                <vs-switch v-model="payout_settings.has_custom_payment_setting" />
            </vs-col>
            <vs-col vs-lg="4" vs-sm="12" class="p-1">
                <div class="grey_holder relative p-4" :class="[payout_settings.has_custom_payment_setting ? 'disable_overlay' : '']">
                    <strong>Settings</strong>
                    <vs-divider />
                    <div class="mb-4">
                        <label class="vs-input--label">Per Hour Payment</label>
                        <div style="background: #fff;" class="cstm_icon_input_holder">
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="11"
                            height="12"
                            viewBox="0 0 11 12"
                            fill="none"
                            >
                            <path
                                d="M4.24 10.256H10.016V12H0.48V10.256H2.16V7.056H0.48V5.744H2.16V5.008C2.16 4.12267 2.352 3.35467 2.736 2.704C3.13067 2.04267 3.70133 1.536 4.448 1.184C5.19467 0.821333 6.09067 0.639999 7.136 0.639999C8.40533 0.639999 9.456 0.890666 10.288 1.392L9.632 3.088C8.98133 2.672 8.112 2.464 7.024 2.464C6.11733 2.464 5.424 2.68267 4.944 3.12C4.47467 3.54667 4.24 4.17067 4.24 4.992V5.744H8.288V7.056H4.24V10.256Z"
                                fill="#5E5873"
                            />
                            </svg>
                            <input
                                class="w-full"
                                type="text"
                                v-model="payout_settings.per_hour_payment"
                            />
                        </div>
                    </div>
                    <div class="mb-4">
                        <label class="vs-input--label">Minimum Daily Guaranteed Hours</label>
                        <div style="background: #fff;" class="cstm_icon_input_holder">
                            <span class="material-icons">update</span>
                            <input
                                class="w-full"
                                type="text"
                                v-model="payout_settings.minimum_hour_payment"
                            />
                        </div>
                    </div>
                    <!-- <vs-button class="block mx-auto mt-4" @click="submitPaymentSetting">Save</vs-button> -->
                </div>
            </vs-col>
            <vs-col vs-lg="8" vs-sm="12" class="p-1">
                <div class="cstm_vuexy_table table-responsive">
                    <table class="w-full">
                        <thead>
                            <tr>
                                <th>Day of The week</th>
                                <th style="max-width: 150px;">Hourly Rate</th>
                                <th >Guaranteed Hour</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(eachData, index) in payout_settings.custom_payment_setting" :key="index">
                                <td>
                                    {{ eachData.day }}
                                </td>
                                <td>
                                    <div v-if="payout_settings.has_custom_payment_setting" style="background: #fff; width: 150px;" class="cstm_icon_input_holder">
                                        <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="11"
                                        height="12"
                                        viewBox="0 0 11 12"
                                        fill="none"
                                        >
                                        <path
                                            d="M4.24 10.256H10.016V12H0.48V10.256H2.16V7.056H0.48V5.744H2.16V5.008C2.16 4.12267 2.352 3.35467 2.736 2.704C3.13067 2.04267 3.70133 1.536 4.448 1.184C5.19467 0.821333 6.09067 0.639999 7.136 0.639999C8.40533 0.639999 9.456 0.890666 10.288 1.392L9.632 3.088C8.98133 2.672 8.112 2.464 7.024 2.464C6.11733 2.464 5.424 2.68267 4.944 3.12C4.47467 3.54667 4.24 4.17067 4.24 4.992V5.744H8.288V7.056H4.24V10.256Z"
                                            fill="#5E5873"
                                        />
                                        </svg>
                                        <input
                                            class="w-full"
                                            type="text"
                                            v-model="eachData.per_hour_payment"
                                        />
                                    </div>
                                    <span v-else style="width: 150px; display: inline-block;">{{ eachData.per_hour_payment?'£'+eachData.per_hour_payment:'' }}</span>
                                </td>
                                <td>
                                    <vs-input v-if="payout_settings.has_custom_payment_setting" style="width: 150px;" icon-after="true" icon="update" v-model="eachData.minimum_hour_payment"/>
                                    <span v-else style="width: 150px; display: inline-block;">{{ eachData.minimum_hour_payment }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    
                </div>
            </vs-col>
        </vs-row>
        <vs-button class="block mx-auto mt-4" @click="submitPaymentSetting">Save</vs-button>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import { updatePaymentSetting, fetchPayoutSetting } from '@/api/user.js'
import {  fetchPaymentOptionsApi } from '@/api/payment'
export default {
  data () {
    return {
      frequency: 'weekly',
      payout_settings: {
        'has_custom_payment_setting': false,
        'per_hour_payment': null,
        'minimum_hour_payment': null,
        'payment_frequency': null,
        'payment_option': null,
        'account_name': null,
        'sort_code': null,
        'account_number': null,
        'paypal_account_email': null,
        'custom_payment_setting': []
      },
      paymentOptionArray: []
    }
  },
  mounted () {
    this.payoutSettingFetch()
    this.getPaymentOptions()
  },
  methods: {
    async getPaymentOptions () {
      try {
        const data = await fetchPaymentOptionsApi()
        this.paymentOptionArray = data.data.data.methods
      } catch (error) {
        //
      }
    },
    async payoutSettingFetch () {
      try {
        this.$vs.loading({
          text: 'Please Wait  ...'
        })
        const payload = {
          user_id:this.$route.params.teacher_id ? this.$route.params.teacher_id : JSON.parse(localStorage.getItem('userInfo')).id
        }
        const customer_id = this.$store.getters.customerId
        const responseList = await fetchPayoutSetting(payload, customer_id)
        this.payout_settings = responseList.data.data.payout_settings
        this.payout_settings.payment_option = responseList.data.data.payout_settings.payment_option
      } catch (error) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    async paymentSettingUpdate () {
      try {
        this.$vs.loading({
          text: 'Please Wait  ...'
        })
        const payload = {
          ...this.payout_settings
        }
        const customer_id = this.$store.getters.customerId
        const responseList = await updatePaymentSetting(payload, customer_id)
        this.payout_settings = responseList.data.data.course
      } catch (error) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    submitPaymentSetting () {
      if (!this.payout_settings.has_custom_payment_setting) {
        this.payout_settings.custom_payment_setting = this.payout_settings.custom_payment_setting.map((ele) => {
          ele.per_hour_payment = this.payout_settings.per_hour_payment
          ele.minimum_hour_payment = this.payout_settings.minimum_hour_payment
          return ele
        })
      }
      this.paymentSettingUpdate()

    }
  },
  components: {
    vSelect
  }
}
</script>
